import { Component, Input, OnInit } from '@angular/core';
import * as Constants from "../../utils/Constants";
import { StorageService } from 'src/app/services/storage.service';
import { ModalController } from '@ionic/angular';
import { EditGeorgianBarTypesComponent } from '../edit-georgian-bar-types/edit-georgian-bar-types.component';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { CalculationAutoUpdateService } from 'src/app/services/calculation-auto-update.service';
type ConfigType = 'shapes' | 'advanced';

@Component({
  selector: 'app-edit-georgian-bars',
  templateUrl: './edit-georgian-bars.component.html',
  styleUrls: ['./edit-georgian-bars.component.scss'],
  standalone: false,
})
export class EditGeorgianBarsComponent implements OnInit {
  @Input() isComparisonMode: boolean = false;
  configType: ConfigType = 'shapes';
  barHeightData: number[] = [1, 2, 3, 4, 5];
  barShapesData: any[] = Constants.data_muntin_shapes;

  selectedBar: number | null = this.barShapesData[0]?.id || null;
  selectedHorizontal: number = this.barHeightData[0];
  selectedVertical: number = this.barHeightData[0];
  storedProject: any;

  isFormValid = true;

  constructor(private modalController: ModalController, private storageService: StorageService,
    private modalHelper: ModalHelperService, private calcAutoUpdate: CalculationAutoUpdateService
  ) { }

  ngOnInit() { }


  ionViewWillEnter() {
    this.init();
  }

  private async init(): Promise<void> {
    try {
      const res = this.isComparisonMode
        ? await this.storageService.getComparedProject()
        : await this.storageService.getProject();
      this.storedProject = res ? JSON.parse(res) : null;

      this.configType = this.storedProject?.windowgeorgianBarType || "shapes";

      if (this.storedProject?.muntin) {
        const muntin = this.storedProject.muntin;
        this.selectedBar = muntin?.shape?.id;
        if (muntin.shape && this.configType == 'advanced') {
          this.selectedVertical = muntin.shape.countVertical;
          this.selectedHorizontal = muntin.shape.countHorizontal;
        }
      }

    } catch (error) {
      console.error('Error initializing spacer data:', error);
    }
  }

  onModeChange(event: CustomEvent) {
    const value = event.detail.value as string | undefined;
    if (value == 'shapes' || value == 'advanced') {
      this.configType = value;
      this.isFormValid = true;
    }
  }
  selectBarOpt(option: any) {
    this.selectedBar = option;
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  private async saveToStorage(payload: any): Promise<void> {
    if (this.isComparisonMode) {
      await this.storageService.updateComparedProject(payload);
    } else {
      await this.storageService.updateProject(payload);
      await this.calcAutoUpdate.triggerAutoUpdate('glass', this.isComparisonMode);
    }
  }

  async next() {
    var muntinShape;
    var muntin = this.storedProject.muntin;
    if (this.configType == 'shapes') {
      if (this.selectedBar) {
        muntinShape = this.findDataById(this.barShapesData, this.selectedBar);
      }
      muntin.shape = muntinShape
      if (muntinShape.id == 1) {
        muntin.spacer = '';
        muntin.psi = 0.00;
      }
      await this.saveToStorage({
        "windowgeorgianBarType": this.configType,
        "muntin": muntin
      });
    } else if (this.configType == 'advanced') {
      await this.saveToStorage({
        "windowgeorgianBarType": this.configType,
        "muntin": {
          "configType": this.storedProject.muntin.configType,
          "muntinspacers1": this.storedProject.muntin.muntinspacers1,
          "muntinspacers2": this.storedProject.muntin.muntinspacers2,
          "muntinspacers3": this.storedProject.muntin.muntinspacers3,
          "muntinspacers4": this.storedProject.muntin.muntinspacers4,
          "psi": this.storedProject.muntin.psi,
          "shape": {
            "countHorizontal": this.selectedHorizontal,
            "countVertical": this.selectedVertical,
            "id": -1,
            "img": "",
            "name": ""
          },
          "spacer": this.storedProject.muntin.spacer,
          "type": this.storedProject.muntin.type,
        }
      });
    }
    if (muntinShape?.id == 1) {
      this.modalHelper.closeAllModals({}, 'confirm');
    } else {
      this.openBarTypesModal();
    }
  }

  async openBarTypesModal() {
    const modal = await this.modalController.create({
      component: EditGeorgianBarTypesComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        isComparisonMode: this.isComparisonMode
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role == 'confirm') {
      console.log('Selected option:', data.selectedOption);
    }
  }

  private findDataById(arrayData: any, id: number): any {
    return arrayData.find((obj: any) => obj.id == id);
  }
}
